const currencySymbols = {
  USD: '$', EUR: '€', GBP: '£', JPY: '¥', ILS: '₪',
  CAD: 'C$', AUD: 'A$', CHF: 'CHF', SEK: 'kr', NOK: 'kr',
  DKK: 'kr', PLN: 'zł', CZK: 'Kč', HUF: 'Ft', BGN: 'лв',
  RON: 'lei', RUB: '₽', TRY: '₺', BRL: 'R$', MXN: 'Mex$',
  INR: '₹', KRW: '₩', SGD: 'S$', ZAR: 'R', EGP: 'E£',
};

const symbolAfterAmount = new Set(['SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'BGN', 'RON']);

export const getCurrencySymbol = (code) =>
  currencySymbols[(code || 'USD').toUpperCase()] || (code || '$');

export const formatPrice = (amount, currencyCode = 'USD', decimals = 2) => {
  const code = (currencyCode || 'USD').toUpperCase();
  const symbol = getCurrencySymbol(code);
  const formatted = Number(amount || 0).toFixed(decimals);
  return symbolAfterAmount.has(code) ? `${formatted} ${symbol}` : `${symbol}${formatted}`;
};

// Derive a currency code from a country name when the service has no stored currencyCode
const countryToCurrency = {
  'israel': 'ILS', 'il': 'ILS',
  'united kingdom': 'GBP', 'gb': 'GBP', 'uk': 'GBP',
  'germany': 'EUR', 'france': 'EUR', 'spain': 'EUR', 'italy': 'EUR',
  'netherlands': 'EUR', 'belgium': 'EUR', 'austria': 'EUR', 'portugal': 'EUR',
  'japan': 'JPY', 'jp': 'JPY',
  'canada': 'CAD', 'ca': 'CAD',
  'australia': 'AUD', 'au': 'AUD',
  'india': 'INR', 'in': 'INR',
  'brazil': 'BRL', 'br': 'BRL',
  'south africa': 'ZAR', 'za': 'ZAR',
};

export const getCurrencyCodeFromCountry = (country) => {
  if (!country) return 'USD';
  return countryToCurrency[country.toLowerCase()] || 'USD';
};

export const formatServicePrice = (service, providerCountry) => {
  const code = service.currencyCode || service.currency_code
    || getCurrencyCodeFromCountry(providerCountry);
  return formatPrice(service.price, code);
};
